import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetChannelsBalanceReportReqData } from "./GetChannelsBalanceReportReqData";
import { GetChannelsBalanceReportResData } from "./GetChannelsBalanceReportResData";

const ENDPOINT = "/cash_flow/channels_balance";

export class GetChannelsBalanceReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";

    params: GetChannelsBalanceReportReqData = null;

    constructor(reqData: GetChannelsBalanceReportReqData) {
        super();
        this.params = reqData;
    }

    public async execute(): Promise<GetChannelsBalanceReportResData> {
        var res = await this.executeCommand(this.params);
        return new GetChannelsBalanceReportResData(res);
    }
}
